import { Link } from "react-router-dom";


export default function InfoCard({ title, desc, linkText, linkDir, bg, image }) {

    return (
        <Link to={linkDir} className="card-link-wrapper">
            <div className="card">
                <div className={`card-image ${bg}`} />

                <div className="card-content">
                    <div className="card-title-row">
                        {image && (
                            <div className="info-card-image-wrap">
                                <img src={image} alt="" className="info-card-image" />
                            </div>
                        )}
                        <h2>{title}</h2>
                    </div>
                    <p className="card-desc">{desc}</p>
                </div>
            </div>

        </Link>
    );
}

